import "./main_dashboard.css";
import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import LogoutConformationPopup from "./LogoutConformationPopup";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faUser, faRightFromBracket, faListUl } from '@fortawesome/free-solid-svg-icons';
import { usePermissions } from "../../controllers/PermissionContext";

const getInitials = (firstName, lastName) => {
  const f = firstName?.charAt(0)?.toUpperCase() || '';
  const l = lastName?.charAt(0)?.toUpperCase() || '';
  return f + l || 'AD';
};

const Top_navbar = ({ title = "Dashboard" }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [popUpOpen, setPopUpOpen]           = useState(false);
  const dropdownRef                          = useRef(null);
  const navigate                             = useNavigate();
  const PERMISSION                           = usePermissions("activeLogs");
  const user                                 = JSON.parse(sessionStorage.getItem("ADMIN-INFO"));

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <>
      <div className="top-navbar">
        {/* Left — page title */}
        <div className="top-navbar-left">
          <h1 className="main_heading">{title}</h1>
        </div>

        {/* Right — user chip + dropdown */}
        <div className="top-navbar-right" ref={dropdownRef}>
          <div
            className="top-navbar-user-chip"
            onClick={() => setIsDropdownOpen(prev => !prev)}
          >
            <div className="top-navbar-avatar">
              {getInitials(user?.admin_first_name, user?.admin_last_name)}
            </div>
            <div className="top-navbar-user-info">
              <span className="top-navbar-name">
                {user?.admin_first_name || 'Admin'} {user?.admin_last_name || ''}
              </span>
              <span className="top-navbar-role">{user?.admin_type || 'Admin'}</span>
            </div>
            <FontAwesomeIcon
              icon={faChevronDown}
              className={`top-navbar-chevron ${isDropdownOpen ? 'rotated' : ''}`}
            />
          </div>

          {isDropdownOpen && (
            <div className="top-navbar-dropdown">
              <button
                className="top-navbar-dd-item"
                onClick={() => { navigate("/sub-admin/addeditdata", { state: user }); setIsDropdownOpen(false); }}
              >
                <FontAwesomeIcon icon={faUser} className="top-navbar-dd-icon" />
                Profile
              </button>

              {(PERMISSION.fullAccess === 'Y' || PERMISSION.list === 'Y') && (
                <button
                  className="top-navbar-dd-item"
                  onClick={() => { navigate("/active-logs"); setIsDropdownOpen(false); }}
                >
                  <FontAwesomeIcon icon={faListUl} className="top-navbar-dd-icon" />
                  Active Logs
                </button>
              )}

              <hr className="top-navbar-dd-divider" />

              <button
                className="top-navbar-dd-item top-navbar-dd-logout"
                onClick={() => { setPopUpOpen(true); setIsDropdownOpen(false); }}
              >
                <FontAwesomeIcon icon={faRightFromBracket} className="top-navbar-dd-icon" />
                Logout
              </button>
            </div>
          )}
        </div>
      </div>

      <LogoutConformationPopup popUpOpen={popUpOpen} togglePopUp={() => setPopUpOpen(false)} />
    </>
  );
};

export default Top_navbar;
